import { useState } from "react";

export interface MonthOption {
  value: string;
  label: string;
}

const useDashboardFilters = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString());
  const [selectedProperties, setSelectedProperties] = useState<string[]>([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>([]);

  const yearOptions = [currentYear + 1, ...Array.from({ length: 3 }, (_, i) => currentYear - i)];

  const monthOptions: MonthOption[] = [
    { value: "1", label: "Enero" },
    { value: "2", label: "Febrero" },
    { value: "3", label: "Marzo" },
    { value: "4", label: "Abril" },
    { value: "5", label: "Mayo" },
    { value: "6", label: "Junio" },
    { value: "7", label: "Julio" },
    { value: "8", label: "Agosto" },
    { value: "9", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  const handlePropertyChange = (value: string) => {
    if (value === "all") {
      setSelectedProperties([]);
    } else {
      setSelectedProperties([value]);
    }
  };

  const goToPreviousMonth = () => {
    const currentMonthNum = parseInt(selectedMonth);
    const currentYearNum = parseInt(selectedYear);
    
    if (currentMonthNum === 1) {
      const previousYear = currentYearNum - 1;
      if (yearOptions.includes(previousYear)) {
        setSelectedYear(previousYear.toString());
        setSelectedMonth("12");
      }
    } else {
      setSelectedMonth((currentMonthNum - 1).toString());
    }
  };

  const goToNextMonth = () => {
    const currentMonthNum = parseInt(selectedMonth);
    const currentYearNum = parseInt(selectedYear);
    
    if (currentMonthNum === 12) {
      const nextYear = currentYearNum + 1;
      if (yearOptions.includes(nextYear)) {
        setSelectedYear(nextYear.toString());
        setSelectedMonth("1");
      }
    } else {
      setSelectedMonth((currentMonthNum + 1).toString());
    }
  };

  const canGoToPreviousMonth = () => {
    const currentMonthNum = parseInt(selectedMonth);
    const currentYearNum = parseInt(selectedYear);
    const minYear = Math.min(...yearOptions);
    return !(currentMonthNum === 1 && currentYearNum === minYear);
  };

  const canGoToNextMonth = () => {
    const currentMonthNum = parseInt(selectedMonth);
    const currentYearNum = parseInt(selectedYear);
    const maxYear = Math.max(...yearOptions);
    return !(currentMonthNum === 12 && currentYearNum === maxYear);
  };

  return {
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth,
    selectedProperties,
    setSelectedProperties,
    selectedOrganizations,
    setSelectedOrganizations,
    yearOptions,
    monthOptions,
    handlePropertyChange,
    goToPreviousMonth,
    goToNextMonth,
    canGoToPreviousMonth,
    canGoToNextMonth,
  };
}

export default useDashboardFilters;